/**
 * Template stubs — wire to /custom-fields when you need dynamic fields.
 */

export interface CustomField {
  id: number;
  entityType: string;
  fieldName: string;
  fieldLabel: string;
  fieldType: 'text' | 'number' | 'date' | 'select' | 'checkbox' | 'textarea';
  options?: unknown[];
  isRequired: boolean;
  validation?: { min?: number; max?: number; minLength?: number; maxLength?: number };
  order: number;
  value?: unknown;
}

export type CustomFieldRow = CustomField & { value?: unknown };

export function useCustomFields(_entityType?: string): {
  data: CustomField[];
  isLoading: boolean;
  error: Error | undefined;
  mutate: () => Promise<void>;
} {
  return {
    data: [],
    isLoading: false,
    error: undefined,
    mutate: async () => {},
  };
}

export function useCustomFieldValues(
  _entityType: string,
  _entityId: number | null,
): {
  data: CustomFieldRow[];
  isLoading: boolean;
  error: Error | undefined;
  mutate: () => Promise<void>;
} {
  return {
    data: [],
    isLoading: false,
    error: undefined,
    mutate: async () => {},
  };
}

export const setCustomFieldValue = async (
  _entityType: string,
  _entityId: number,
  _customFieldId: number,
  _value: unknown,
): Promise<void> => {
  /* no-op */
};
